<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.develop_stage_high_forest" name="highForest">
          <option disabled value="">{{ $t("localization.highForest") }}</option>
          <option v-for="(hf, key) in highForestList" :value="key" :key="key">{{ hf }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.develop_stage_coppice" name="coppice">
          <option disabled value="">{{ $t("localization.coppice") }}</option>
          <option v-for="(cp, key) in coppiceList" :value="key" :key="key">{{ cp }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.develop_stage_shrub" name="shrub">
          <option disabled value="">{{ $t("localization.shrub") }}</option>
          <option v-for="(sh, key) in shrubList" :value="key" :key="key">{{ sh }}</option>
        </select>
      </md-field>
    </div>
  </div>
</template>

<script>
import { getDomain } from '@/assets/scripts/domainsManager'

const HIGH_FOREST = 'develop_stage_high_forest'
const COPPICE = 'develop_stage_coppice'
const SHRUB = 'develop_stage_shrub'

export default {
  name: 'DevelopmentStage',
  data: () => ({
    highForestList: {},
    coppiceList: {},
    shrubList: {}
  }),
  mounted () {
    getDomain(HIGH_FOREST).then(data => {
      this.highForestList = data[this.$i18n.locale]
    })
    getDomain(COPPICE).then(data => {
      this.coppiceList = data[this.$i18n.locale]
    })
    getDomain(SHRUB).then(data => {
      this.shrubList = data[this.$i18n.locale]
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
